import request from '@/utils/service'

export function communityListApi(data) {
  return request({
    url: '/residentialArea/list',
    method: 'post',
    params: data
  })
}
export function communityDetailApi(data) {
  return request({
    url: '/residentialArea/detail',
    method: 'post',
    params: data
  })
}
export function addCommunityApi(data) {
  return request({
    url: '/residentialArea/add',
    method: 'post',
    data
  })
}
export function updateCommunityApi(data) {
  return request({
    url: '/residentialArea/update',
    method: 'post',
    data
  })
}
export function deleteCommunityApi(data) {
  return request({
    url: '/residentialArea/delete',
    method: 'post',
    data
  })
}
export function setCommunityStatus(data) {
  return request({
    url: '/residentialArea/updateStatus',
    method: 'post',
    data
  })
}

// 场地类型
export function storeTypeApi(data) {
  return request({
    url: '/storeType/list',
    method: 'get',
    params: data
  })
}


// 收费标准
export function feeStandardsListApi(data) {
  return request({
    url: '/residentialAreaChargePlan/list',
    method: 'post',
    params: data
  })
}

// 分成设置
export function divvySettingListApi(data) {
  return request({
    url: '/residentialAreaDivide/list',
    method: 'post',
    params: data
  })
}
export function addDivvySettingApi(data) {
  return request({
    url: '/residentialAreaDivide/add',
    method: 'post',
    data
  })
}
export function updateDivvySettingApi(data) {
  return request({
    url: '/residentialAreaDivide/update',
    method: 'post',
    data
  })
}
export function deleteDivvySettingApi(data) {
  return request({
    url: '/residentialAreaDivide/delete',
    method: 'post',
    data
  })
}
